// extracted by mini-css-extract-plugin
export default {"wrap":"InlineEditRow_wrap__DdEjB","row":"InlineEditRow_row__y6IpV","input":"InlineEditRow_input__O4FTL","actions":"InlineEditRow_actions__vhGXY"};